export const handelOpenModalEditAddress = (address) => ({
    type: 'OPEN_MODAL_EDIT_ADDRESS',address
});
export const handelCloseModalEditAddress = () => ({
    type: 'CLOSE_MODAL_EDIT_ADDRESS'
});

export const actionChangeInputsModalEditAddress = (name,value) => ({
    type: 'CHANGE_INPUTS_MODAL_EDIT_ADDRESS',name,value
});
export const actionChangeLocationModalEditAddress = (lng,lat) => ({
    type: 'CHANGE_LOCATION_MODAL_EDIT_ADDRESS',lng,lat
});
